import React from "react";

const AppleIcon = ({fill}) => (
  <svg
  width="25"
  height="25"
  viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M16.0477 4.17877C15.1883 5.20695 13.813 6.01819 12.4379 5.9022C12.266 4.51199 12.9392 3.03461 13.7271 2.12214C14.5865 1.065 16.0907 0.311831 17.3083 0.253906C17.4515 1.70218 16.8928 3.12149 16.0477 4.17877ZM17.2941 6.17748C15.3029 6.06163 13.5983 7.32151 12.6529 7.32151C11.6932 7.32151 10.2463 6.23541 8.67068 6.26437C6.62236 6.29334 4.71712 7.46632 3.67141 9.3347C1.52268 13.0713 3.11281 18.6039 5.18978 21.6453C6.20685 23.1515 7.42444 24.8025 9.02875 24.7445C10.5473 24.6866 11.1488 23.7453 12.9825 23.7453C14.8303 23.7453 15.3603 24.7445 16.9647 24.7156C18.6263 24.6866 19.672 23.2095 20.689 21.7032C21.8492 19.9942 22.322 18.3286 22.3506 18.2417C22.322 18.2128 19.142 16.9818 19.1134 13.274C19.0847 10.1748 21.6202 8.69752 21.7348 8.61063C20.3022 6.46711 18.0677 6.23541 17.2941 6.17748Z"
      fill={fill}
    />
  </svg>
);

export default AppleIcon;
